import "./select.css";

export default function Select({
   name,
   value,
   error,
   label,
   placeholder = "Wybierz",
   options,
   disabled,
   style,
   label_style,
   ariaLabel,
   onChange
}) {
   return (
      <div className="zsk-form-select" style={ style }>

         { label && 
            <div className="zsk-form-select-label" style={ label_style }>
               { label }
            </div>
         }

         <select
            name={ name }
            value={ value || "" }
            disabled={ disabled }
            aria-label={ ariaLabel || (label ? `${label} z listy rozwijanej` : undefined) }
            onChange={ e => onChange && onChange(
               name,
               e.target.value === "" ? undefined : e.target.value,
               options.find( o => String( o.value ) === String( e.target.value ))
            )}
         >
            { placeholder && 
               <option value="" selected style={{ color: "#6B6B6B" }}> { placeholder } </option>
            }

            { options && options.map(({ value, label, disabled }) => (
               <option 
                  key={ value } 
                  value={ value }
                  disabled={ disabled }
               > { label } </option>
            ))}
         </select>

         { error && <div className="error"> { error } </div> }
      </div>
   )
}